import { MenuElement } from "../interfaces/interfaces";

export const HOME_MENU_ELEMENT: MenuElement = {
    title: 'Főoldal',
    routerLink: '/',
    icon: 'pi pi-home',
    exact: true,
    permissions: []
};

export const USERS_MENU_ELEMENT: MenuElement = {
    title: 'Felhasználók',
    routerLink: 'users',
    icon: 'pi pi-user',
    exact: false,
    permissions: ['users', 'users.list']
};

export const USERGORUS_MENU_ELEMENT: MenuElement = {
    title: 'Felhasználói csoportok',
    routerLink: 'usergroups',
    icon: 'pi pi-users',
    exact: false,
    permissions: ['usergroups', 'usergroups.list']
};

export const PRODUCTS_MENU_ELEMENT: MenuElement = {
    title: 'Termékek',
    routerLink: 'products',
    icon: 'pi pi-sitemap',
    exact: false,
    permissions: ['products', 'products.list']
};

export const CATEGORIES_MENU_ELEMENT: MenuElement = {
    title: 'Kategóriák',
    routerLink: 'categories',
    icon: 'pi pi-sitemap',
    exact: false,
    permissions: ['categories', 'categories.list']
};

export const CUSTOMERGROUPS_MENU_ELEMENT: MenuElement = {
    title: 'Vevőcsoportok',
    routerLink: 'customergroups',
    icon: 'pi pi-users',
    exact: false,
    permissions: ['customergroups', 'customergroups.list']
};

export const CUSTOMERS_MENU_ELEMENT: MenuElement = {
    title: 'Vevők',
    routerLink: 'customers',
    icon: 'pi pi-users',
    exact: false,
    permissions: ['customers', 'customers.list']
};

export const PRODUCTATTRIBUITES_MENU_ELEMENT: MenuElement = {
    title: 'Termékattribútumok',
    routerLink: 'productattributes',
    icon: 'pi pi-ticket',
    exact: false,
    permissions: ['attributes', 'attributes.list']
};

export const PAYMENT_METHODS_MENU_ELEMENT: MenuElement = {
    title: 'Fizetési módok',
    routerLink: 'paymentmethods',
    icon: 'pi pi-wallet',
    exact: false,
    permissions: ['paymentmethods', 'paymentmethods.list']
};

export const SHIPPING_METHODS_MENU_ELEMENT: MenuElement = {
    title: 'Szállítási módok',
    routerLink: 'shippingmethods',
    icon: 'pi pi-shopping-cart',
    exact: false,
    permissions: ['shippingmethods', 'shippingmethods.list']
};

export const CURRENCIES_MENU_ELEMENT: MenuElement = {
    title: 'Pénznemek',
    routerLink: 'currencies',
    icon: 'pi pi-money-bill',
    exact: false,
    permissions: ['currencies', 'currencies.list']
};

export const PRODUCTPRICETYPES_MENU_ELEMENT: MenuElement = {
    title: 'Termékártípusok',
    routerLink: 'productpricetypes',
    icon: 'pi pi-dollar',
    exact: false,
    permissions: ['prices', 'prices.list']
};

export const BANNERS_MENU_ELEMENT: MenuElement = {
    title: 'Bannerek',
    routerLink: 'banners',
    icon: 'pi pi-image',
    exact: false,
    permissions: ['banners', 'banners.list']
};

export const CARTSTATISTICS_MENU_ELEMENT: MenuElement = {
    title: 'Kosárstatisztika',
    routerLink: 'cartstatistics',
    icon: 'pi pi-shopping-cart',
    exact: false,
    permissions: ['statistics', 'statistics.cart']
};

export const ORDERS_MENU_ELEMENT: MenuElement = {
    title: 'Rendelések',
    routerLink: 'orders',
    icon: 'pi pi-shopping-cart',
    exact: false,
    permissions: ['orders', 'orders.list']
};

export const FILES_MENU_ELEMENT: MenuElement = {
    title: 'Fileok',
    routerLink: 'files',
    icon: 'pi pi-cloud-download',
    exact: false,
    permissions: ['files', 'files.list']
};

export const FAQ_MENU_ELEMENT: MenuElement = {
    title: 'Gyik',
    routerLink: 'faq',
    icon: 'pi pi-question-circle',
    exact: false,
    permissions: ['faq', 'faq.list']
};

export const PAGES_MENU_ELEMENT: MenuElement = {
    title: 'Oldalak',
    routerLink: 'pages',
    icon: 'pi pi-file',
    exact: false,
    permissions: ['pages', 'pages.list']
};

export const SETTINGS_MENU_ELEMENT: MenuElement = {
    title: 'Beállítások',
    routerLink: 'settings',
    icon: 'pi pi-cog',
    exact: false,
    permissions: ['settings', 'settings.list']
};

export const MODULES_MENU_ELEMENT: MenuElement = {
    title: 'Modulok',
    routerLink: 'modules',
    icon: 'pi pi-th-large',
    exact: false,
    permissions: ['modules', 'modules.list']
};

export const BLOGS_MENU_ELEMENT: MenuElement = {
    title: 'Blog',
    routerLink: 'blogs',
    icon: 'pi pi-th-large',
    exact: false,
    permissions: ['blogs', 'blogs.list']
};

export const GENERAL_MENU_ELEMENTS: MenuElement[] = [
    HOME_MENU_ELEMENT,
    USERS_MENU_ELEMENT,
    USERGORUS_MENU_ELEMENT,
    PRODUCTS_MENU_ELEMENT,
    PAYMENT_METHODS_MENU_ELEMENT,
    SHIPPING_METHODS_MENU_ELEMENT,
    CATEGORIES_MENU_ELEMENT,
    CUSTOMERGROUPS_MENU_ELEMENT,
    CUSTOMERS_MENU_ELEMENT,
    PRODUCTATTRIBUITES_MENU_ELEMENT,
    CURRENCIES_MENU_ELEMENT,
    PRODUCTPRICETYPES_MENU_ELEMENT,
    BANNERS_MENU_ELEMENT,
    CARTSTATISTICS_MENU_ELEMENT,
    ORDERS_MENU_ELEMENT,
    FILES_MENU_ELEMENT,
    FAQ_MENU_ELEMENT,
    PAGES_MENU_ELEMENT,
    BLOGS_MENU_ELEMENT,
    MODULES_MENU_ELEMENT,
    SETTINGS_MENU_ELEMENT
];
